import {add, isAfter} from 'date-fns'
import {Observable, of} from "rxjs";

export class CachedData<T> {
  public lastLoaded: Date;
  private _numSecondsToKeep: number;
   data: T[] = [];

  constructor(data: T[], numSecondsToKeep: number = 300) {
    this._numSecondsToKeep = numSecondsToKeep;
    this.data = data;
    //this.lastLoaded = new Date();
  }

  invalidateData() {
    this.lastLoaded = null;
  }

  isDataFresh() {
    if (this.lastLoaded == null)
      return false;

    return isAfter(this.lastLoaded, add(new Date(), {seconds: -1 * this._numSecondsToKeep}));
  }

  clear() {
    this.data.length = 0;
  }

  addData(dataPoint: T) {
    this.data.push(dataPoint);
  }
}
